/**
 * BudgetCheckService
 * Advisory budget check (dry run of the routing algorithm) + explicit budget
 * selections for purchase requests.
 * Routes: api/budget-check, api/budget-selections
 */
export class BudgetCheckService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetCheckService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(path) {
        const url = `${this.servicePath}/${path}`;
        return url.startsWith('/') ? url : '/' + url;
    }
    /**
     * Side-effect-free advisory check: which budget would this spend hit and how
     * healthy would it be after approval. Never blocks — matched=false means NoBudget.
     */
    async check(query) {
        const params = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
            if (value !== undefined && value !== null)
                params.append(key, String(value));
        });
        const qs = params.toString();
        const response = await this.http.get(this.buildUrl(qs ? `api/budget-check?${qs}` : 'api/budget-check'));
        if (!response.data)
            throw new Error('Budget check failed');
        return response.data;
    }
    // ---- explicit selections ----
    /** Pin a purchase request to a specific budget/allocation (overrides routing). */
    async createSelection(body) {
        const response = await this.http.post(this.buildUrl('api/budget-selections'), body);
        if (!response.data)
            throw new Error(`Failed to create budget selection for request ${body.requestID}`);
        return response.data;
    }
    /** The explicit selection for a purchase request. */
    async getSelection(requestId) {
        const response = await this.http.get(this.buildUrl(`api/budget-selections/${requestId}`));
        if (!response.data)
            throw new Error(`Budget selection for request ${requestId} not found`);
        return response.data;
    }
    /** Remove the explicit selection (falls back to automatic routing). */
    async deleteSelection(requestId) {
        const response = await this.http.delete(this.buildUrl(`api/budget-selections/${requestId}`));
        return response.success;
    }
}
BudgetCheckService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetCheckService.js.map